import { render, staticRenderFns } from "./companyNewsDetail.vue?vue&type=template&id=53c63852&scoped=true&"
import script from "./companyNewsDetail.vue?vue&type=script&lang=js&"
export * from "./companyNewsDetail.vue?vue&type=script&lang=js&"
import style0 from "./companyNewsDetail.vue?vue&type=style&index=0&id=53c63852&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c63852",
  null
  
)

export default component.exports